import { useState, useEffect } from 'react';
import { collection, query, onSnapshot, orderBy, limit, getDocs } from 'firebase/firestore';
import { useSelector } from 'react-redux';
import { DB } from 'src/contexts/FirebaseContext';
import { selectCurrentWorkspaceId } from 'src/redux/slices/userSlice';

export interface Transformation {
  id: string;
  imageUrl: string;
  fileName: string;
  createdAt: any;
  title: string;
  description: string;
}

export default function useTransformations() {
  const [transformations, setTransformations] = useState<Transformation[]>([]);
  const [loading, setLoading] = useState(true);
  const workspaceId = useSelector(selectCurrentWorkspaceId);

  useEffect(() => {
    if (!workspaceId) {
      setLoading(false);
      return;
    }

    const transformationsRef = collection(DB, `workspaceReviews/${workspaceId}/transformations`);
    const q = query(transformationsRef, orderBy('createdAt', 'desc'));

    const unsubscribe = onSnapshot(
      q,
      (querySnapshot) => {
        const transformationsData: Transformation[] = [];
        querySnapshot.forEach((doc) => {
          transformationsData.push({ id: doc.id, ...doc.data() } as Transformation);
        });
        setTransformations(transformationsData);
        setLoading(false);
      },
      (error) => {
        console.error('Error fetching transformations:', error);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [workspaceId]);

  return { transformations, loading };
}
export function useHasTransformations() {
  const [hasTransformations, setHasTransformations] = useState(false);
  const [loading, setLoading] = useState(true);
  const workspaceId = useSelector(selectCurrentWorkspaceId);

  useEffect(() => {
    if (!workspaceId) {
      setLoading(false);
      return;
    }

    const transformationsRef = collection(DB, `workspaceReviews/${workspaceId}/transformations`);
    const q = query(transformationsRef, orderBy('createdAt', 'desc'), limit(1));

    getDocs(q).then((querySnapshot) => {
      const transformationsData: Transformation[] = [];
      querySnapshot.forEach((doc) => {
        transformationsData.push({ id: doc.id, ...doc.data() } as Transformation);
      });
      setHasTransformations(transformationsData.length > 0);
      setLoading(false);
    })
    .catch((error) => {
      console.error('Error fetching transformations:', error);
      setLoading(false);
    });

    return () => {
      setLoading(false);
    };
  }, [workspaceId]);

  return { hasTransformations, loading };
}
